/**
 * Copyright © 2026 Adnuntius AS.
 */
import {DestroyRef, Component, OnInit} from '@angular/core';
import * as _ from 'lodash';

import template from './chain-counts-page.component.html';
import {SIMPLE_PAGE_IMPORTS} from './simple-page-imports';
import {NetworkInfoApiService} from './network-info-api.service';
import {SignalPageState} from '../../common/controller/signal-page-state';

const CHAIN_LEVELS = [
  {value: 'ADVERTISER', label: 'Advertiser'},
  {value: 'ORDER', label: 'Order'},
  {value: 'LINE_ITEM', label: 'Line Item'},
  {value: 'CREATIVE', label: 'Creative'}
];

@Component({
  standalone: true,
  imports: SIMPLE_PAGE_IMPORTS,
  selector: 'adn-chain-counts-page',
  template
})
export class ChainCountsPageComponent implements OnInit {
  readonly chainLevels = CHAIN_LEVELS;

  startLevel = 'ADVERTISER';
  endLevel = 'LINE_ITEM';
  delivering = true;
  readyToDeliver = true;

  readonly page: SignalPageState<any, Record<string, any>>;
  get results(): any[] { return this.page.items(); }
  get searched(): boolean { return this.page.loaded(); }
  constructor(
    private readonly networkInfoApi: NetworkInfoApiService,
    destroyRef: DestroyRef
  ) {
    this.page = new SignalPageState((query, page, pageSize) => this.networkInfoApi.getChainCounts({...query, page, pageSize}), 50, destroyRef);
  }

  ngOnInit(): void {
    this.runQuery(true);
  }

  startLevelOptions(): any[] {
    return _.filter(this.chainLevels, (level) => level.value !== 'CREATIVE');
  }

  endLevelOptions(): any[] {
    const startIndex = _.findIndex(this.chainLevels, {value: this.startLevel});
    return _.filter(this.chainLevels, (_level, index) => index > startIndex);
  }

  onStartLevelChange(): void {
    const endOptions = this.endLevelOptions();
    if (!_.find(endOptions, {value: this.endLevel})) {
      this.endLevel = _.get(endOptions, [0, 'value']);
    }
  }

  runQuery(resetPage = false): void {
    if (!this.startLevel || !this.endLevel) return;
    this.page.load({startLevel: this.startLevel, endLevel: this.endLevel,
      delivering: this.delivering, readyToDeliver: this.readyToDeliver}, resetPage);
  }

  levelLabel(value: string): string {
    return _.get(_.find(this.chainLevels, {value}), 'label', value);
  }

  countColumnLabel(): string {
    return this.levelLabel(this.endLevel) + ' count';
  }

  rowStateName(): string {
    switch (this.startLevel) {
      case 'ADVERTISER':
        return 'app.adv.advertisers.advertiser';
      case 'ORDER':
        return 'app.adv.orders.order';
      case 'LINE_ITEM':
        return 'app.adv.line-items.line-item';
      default:
        return '';
    }
  }
}
